import React from "react";
import ComingSoon from "./ComingSoon";

const BDM = () => <ComingSoon title="BDM" />;

export default BDM;
